import React from 'react';

const DesignOrderModal = () => {
	return (
		<div className="wraper container-fluid dashboard-container">
			<div className="popup-wrapper">
				{/* supplier-upload-modal */}
				<div className="common-popup all-order-modal">
					<div className="common-popup-header border-0 d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="medium-14 mb-0">All Designs (1/20)</h3>
						</div>
						<div className="m-0 search-filter">
							<div className="with-icon right-icon">
								<input type="text" placeholder="Search with design no" defaultValue />
								<span className="right-icon">
									<img src="/icons/search.png" alt="" />
								</span>
							</div>
						</div>
					</div>
					<div className="common-popup-body pt-0 scroll-x-label">
						<div className="all-order-design">
							<div className="order-items">
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
								<div className="single-design-card">
									<div className="card-top">
										<img src="/images/t-shirt-orange.PNG" alt="" />
										<div className="check-icon">
											<img src="/icons/completed-icon.svg" width={24} alt="" />
											{/* <img src="/icons/check-gray-round.svg" width="24" alt=""> */}
										</div>
									</div>
									<div className="card-content mt-2">
										<h3 className="regular-12 gray_dark_01 design-title">
											BFb23-Sa-Ba-La-
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DesignOrderModal;
